<div class="confirmation-screen">
  <div class="form-title">
    Confirma que los datos del cashout estén correctos para continuar.
  </div>

  <div class="confirmation-details">
    <div class="confirmation-item" *ngFor="let detail of details">
      <span class="confirmation-label">{{ detail.label }}</span>
      <span class="confirmation-value">{{ detail.value }}</span>
    </div>
  </div>

  <div class="buttons-container">
    <p-button
      label="Volver"
      [outlined]="true"
      [disabled]="addingTransaction"
      (click)="back.emit()"
    />
    <p-button
      label="Confirmar cashout"
      severity="secondary"
      [loading]="addingTransaction"
      [disabled]="addingTransaction"
      (click)="confirm.emit()"
    />
  </div>
</div>

